import IncentivizeMyTripsLoginComponent from "@components/MytripsLoginAuthFlow/IncentivizeMyTripsLogin";
import MytripsLoginAuthFlowComponent from "@components/MytripsLoginAuthFlow/MyTripsLogin";
import type { MytripsLoginAuthFlowProps } from "@components/MytripsLoginAuthFlow/MyTripsLogin/contract";
import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withAuthContext from "./withAuthContext";

export default withAuthContext<MytripsLoginAuthFlowProps>(
  withErrorBoundary(MytripsLoginAuthFlowComponent, {
    name: "MytripsLoginAuthFlow",
  }),
);

export const IncentivizeMyTripsLogin =
  withAuthContext<MytripsLoginAuthFlowProps>(
    withErrorBoundary(IncentivizeMyTripsLoginComponent, {
      name: "IncentivizeMyTripsLogin",
    }),
  );
